import v from "@babel/runtime/helpers/esm/objectSpread2";
import z from "@babel/runtime/helpers/esm/classCallCheck";
import A from "@babel/runtime/helpers/esm/createClass";
import T from "@babel/runtime/helpers/esm/assertThisInitialized";
import k from "@babel/runtime/helpers/esm/inherits";
import E from "@babel/runtime/helpers/esm/createSuper";
import n from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as X } from "@semcore/utils/lib/core/index";
import V, { sstyled as m, assignProps as p, Component as D } from "@semcore/core";
import i from "react";
import { Box as C } from "@semcore/flex-box";
import Y from "@semcore/utils/lib/addonTextChildren";
import N from "@semcore/utils/lib/logger";
import R from "@semcore/icon/Close/m";
import { localizedMessages as w } from "./translations/__intergalactic-dynamic-locales.mjs";
import F from "@semcore/utils/lib/enhances/i18nEnhance";
import I from "@semcore/utils/lib/enhances/resolveColorEnhance";
import U from "@semcore/utils/lib/uniqueID";
import M from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import { isAdvanceMode as Z } from "@semcore/utils/lib/findComponent";
var K = (
  /*__reshadow_css_start__*/
  (X.insert(
    /*__inner_css_start__*/
    `.___SCircle_17ogj_gg_{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;border-radius:50%;margin:0 var(--intergalactic-spacing-1x, 4px)}.___SCircle_17ogj_gg_:first-child{margin-left:0}.___SCircle_17ogj_gg_:last-child{margin-right:0}.___SCircle_17ogj_gg_._size_m_17ogj_gg_{width:16px;height:16px}.___SCircle_17ogj_gg_._size_l_17ogj_gg_,.___SCircle_17ogj_gg_._size_xl_17ogj_gg_{width:20px;height:20px}.___SAddon_17ogj_gg_,.___STagContainerClose_17ogj_gg_,.___STag_17ogj_gg_{position:relative;display:inline-flex;align-items:center;justify-content:center;padding-left:var(--intergalactic-spacing-1x, 4px);padding-right:var(--intergalactic-spacing-1x, 4px)}.___SAddon_17ogj_gg_{flex-shrink:0}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_{padding-left:0;padding-right:0}.___STagContainerClose_17ogj_gg_,.___STag_17ogj_gg_{vertical-align:middle;border:1px solid var(--intergalactic-bg-primary-neutral, #ffffff);box-sizing:border-box;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);border-radius:var(--intergalactic-tag-rounded, 24px);font-weight:var(--intergalactic-medium, 500);color:var(--tag-color_17ogj)}.___STagContainerClose_17ogj_gg_.__interactive_17ogj_gg_.__keyboardFocused_17ogj_gg_,.___STag_17ogj_gg_.__interactive_17ogj_gg_.__keyboardFocused_17ogj_gg_{box-shadow:var(--intergalactic-keyboard-focus,
      0px 0px 0px 3px rgba(0, 143, 248, 0.5)
    );z-index:1}.___STagContainerClose_17ogj_gg_::before,.___STag_17ogj_gg_::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:var(--intergalactic-tag-rounded, 24px);background-color:var(--tag-color_17ogj);opacity:.2;filter:brightness(150%)}.___STagContainerClose_17ogj_gg_::after,.___STag_17ogj_gg_::after{content:"";position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;border-radius:var(--intergalactic-tag-rounded, 24px);pointer-events:none;border:1px solid var(--tag-color_17ogj);opacity:.1;filter:brightness(150%)}.___STagContainerClose_17ogj_gg_:active,.___STagContainerClose_17ogj_gg_:focus,.___STag_17ogj_gg_:active,.___STag_17ogj_gg_:focus{outline:0;-webkit-text-decoration:none;text-decoration:none}@media (hover:hover){.___STagContainerClose_17ogj_gg_:hover,.___STag_17ogj_gg_:hover{outline:0;-webkit-text-decoration:none;text-decoration:none}}.___STagContainerClose_17ogj_gg_.__disabled_17ogj_gg_,.___STag_17ogj_gg_.__disabled_17ogj_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___STag_17ogj_gg_.__interactiveView_17ogj_gg_{cursor:pointer}.___STagContainerClose_17ogj_gg_._size_m_17ogj_gg_,.___STagContainer_17ogj_gg_._size_m_17ogj_gg_ .___SAddon_17ogj_gg_,.___STag_17ogj_gg_._size_m_17ogj_gg_{height:20px;min-width:20px}.___STagContainerClose_17ogj_gg_._size_m_17ogj_gg_ .___SCircle_17ogj_gg_:first-child,.___STagContainer_17ogj_gg_._size_m_17ogj_gg_ .___SAddon_17ogj_gg_ .___SCircle_17ogj_gg_:first-child,.___STag_17ogj_gg_._size_m_17ogj_gg_ .___SCircle_17ogj_gg_:first-child{margin-left:calc(-1*var(--intergalactic-spacing-05x, 2px))}.___STagContainerClose_17ogj_gg_._size_m_17ogj_gg_ .___SCircle_17ogj_gg_:last-child,.___STagContainer_17ogj_gg_._size_m_17ogj_gg_ .___SAddon_17ogj_gg_ .___SCircle_17ogj_gg_:last-child,.___STag_17ogj_gg_._size_m_17ogj_gg_ .___SCircle_17ogj_gg_:last-child{margin-right:calc(-1*var(--intergalactic-spacing-05x, 2px))}.___STagContainerClose_17ogj_gg_._size_m_17ogj_gg_ .___SText_17ogj_gg_,.___STagContainer_17ogj_gg_._size_m_17ogj_gg_ .___SAddon_17ogj_gg_ .___SText_17ogj_gg_,.___STag_17ogj_gg_._size_m_17ogj_gg_ .___SText_17ogj_gg_{font-size:var(--intergalactic-fs-100, 12px);line-height:var(--intergalactic-lh-100, 133%)}.___STagContainerClose_17ogj_gg_._size_l_17ogj_gg_,.___STagContainer_17ogj_gg_._size_l_17ogj_gg_ .___SAddon_17ogj_gg_,.___STag_17ogj_gg_._size_l_17ogj_gg_{height:28px;min-width:28px}.___STagContainerClose_17ogj_gg_._size_l_17ogj_gg_ .___SText_17ogj_gg_,.___STagContainer_17ogj_gg_._size_l_17ogj_gg_ .___SAddon_17ogj_gg_ .___SText_17ogj_gg_,.___STag_17ogj_gg_._size_l_17ogj_gg_ .___SText_17ogj_gg_{font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%)}.___STagContainerClose_17ogj_gg_._size_xl_17ogj_gg_,.___STag_17ogj_gg_._size_xl_17ogj_gg_{height:40px;min-width:40px;padding:0 var(--intergalactic-spacing-2x, 8px)}.___STagContainerClose_17ogj_gg_._size_xl_17ogj_gg_ .___SText_17ogj_gg_,.___STag_17ogj_gg_._size_xl_17ogj_gg_ .___SText_17ogj_gg_{font-size:var(--intergalactic-fs-300, 16px);line-height:var(--intergalactic-lh-300, 150%)}.___STagContainerClose_17ogj_gg_._theme_primary_17ogj_gg_::before,.___STagContainer_17ogj_gg_._theme_primary_17ogj_gg_ .___SAddon_17ogj_gg_::before,.___STag_17ogj_gg_._theme_primary_17ogj_gg_::before{top:-1px;left:-1px;right:-1px;bottom:-1px}.___STagContainerClose_17ogj_gg_._theme_primary_17ogj_gg_:after,.___STagContainer_17ogj_gg_._theme_primary_17ogj_gg_ .___SAddon_17ogj_gg_:after,.___STag_17ogj_gg_._theme_primary_17ogj_gg_:after{display:none}.___STagContainerClose_17ogj_gg_._theme_primary_17ogj_gg_.__active_17ogj_gg_:before,.___STagContainerClose_17ogj_gg_._theme_primary_17ogj_gg_.__interactiveView_17ogj_gg_:active:before,.___STagContainer_17ogj_gg_._theme_primary_17ogj_gg_ .___SAddon_17ogj_gg_.__active_17ogj_gg_:before,.___STagContainer_17ogj_gg_._theme_primary_17ogj_gg_ .___SAddon_17ogj_gg_.__interactiveView_17ogj_gg_:active:before,.___STag_17ogj_gg_._theme_primary_17ogj_gg_.__active_17ogj_gg_:before,.___STag_17ogj_gg_._theme_primary_17ogj_gg_.__interactiveView_17ogj_gg_:active:before{opacity:.3}@media (hover:hover){.___STagContainerClose_17ogj_gg_._theme_primary_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before,.___STagContainer_17ogj_gg_._theme_primary_17ogj_gg_ .___SAddon_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before,.___STag_17ogj_gg_._theme_primary_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before{opacity:.3}}.___STagContainerClose_17ogj_gg_._theme_additional_17ogj_gg_::before,.___STagContainerClose_17ogj_gg_._theme_secondary_17ogj_gg_::before,.___STag_17ogj_gg_._theme_additional_17ogj_gg_::before,.___STag_17ogj_gg_._theme_secondary_17ogj_gg_::before{opacity:.01}.___STagContainerClose_17ogj_gg_._theme_additional_17ogj_gg_.__active_17ogj_gg_:before,.___STagContainerClose_17ogj_gg_._theme_additional_17ogj_gg_.__interactiveView_17ogj_gg_:active:before,.___STagContainerClose_17ogj_gg_._theme_secondary_17ogj_gg_.__active_17ogj_gg_:before,.___STagContainerClose_17ogj_gg_._theme_secondary_17ogj_gg_.__interactiveView_17ogj_gg_:active:before,.___STag_17ogj_gg_._theme_additional_17ogj_gg_.__active_17ogj_gg_:before,.___STag_17ogj_gg_._theme_additional_17ogj_gg_.__interactiveView_17ogj_gg_:active:before,.___STag_17ogj_gg_._theme_secondary_17ogj_gg_.__active_17ogj_gg_:before,.___STag_17ogj_gg_._theme_secondary_17ogj_gg_.__interactiveView_17ogj_gg_:active:before{opacity:.1}@media (hover:hover){.___STagContainerClose_17ogj_gg_._theme_additional_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before,.___STagContainerClose_17ogj_gg_._theme_secondary_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before,.___STag_17ogj_gg_._theme_additional_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before,.___STag_17ogj_gg_._theme_secondary_17ogj_gg_.__interactiveView_17ogj_gg_:hover:before{opacity:.1}}.___SClose_17ogj_gg_ path,.___STagContainerClose_17ogj_gg_._theme_additional-invert_17ogj_gg_::after,.___STagContainerClose_17ogj_gg_._theme_additional_17ogj_gg_::after,.___STagContainerClose_17ogj_gg_._theme_secondary-invert_17ogj_gg_::after,.___STagContainerClose_17ogj_gg_._theme_secondary_17ogj_gg_::after,.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_ svg path,.___STag_17ogj_gg_._theme_additional-invert_17ogj_gg_::after,.___STag_17ogj_gg_._theme_additional_17ogj_gg_::after,.___STag_17ogj_gg_._theme_secondary-invert_17ogj_gg_::after,.___STag_17ogj_gg_._theme_secondary_17ogj_gg_::after{opacity:.5}.___STagContainerClose_17ogj_gg_._theme_primary-invert_17ogj_gg_,.___STag_17ogj_gg_._theme_primary-invert_17ogj_gg_{background-color:var(--intergalactic-tag-primary-white-normal,
    rgba(255, 255, 255, 0.15)
  );color:var(--intergalactic-text-primary-invert, #ffffff)}.___STagContainerClose_17ogj_gg_._theme_additional-invert_17ogj_gg_,.___STagContainerClose_17ogj_gg_._theme_secondary-invert_17ogj_gg_,.___STag_17ogj_gg_._theme_additional-invert_17ogj_gg_,.___STag_17ogj_gg_._theme_secondary-invert_17ogj_gg_{color:var(--intergalactic-text-primary-invert, #ffffff)}.___STag_17ogj_gg_._theme_additional_17ogj_gg_::after{border-style:dashed}.___SText_17ogj_gg_{display:inline-block;padding-left:var(--intergalactic-spacing-1x, 4px);padding-right:var(--intergalactic-spacing-1x, 4px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;outline:0;position:relative}.___SText_17ogj_gg_.__keyboardFocused_17ogj_gg_{box-shadow:var(--intergalactic-keyboard-focus,
    0px 0px 0px 3px rgba(0, 143, 248, 0.5)
  );z-index:1}.___SText_17ogj_gg_:not(:only-child):first-child{padding-right:0}.___SText_17ogj_gg_:not(:first-child):not(:last-child){padding-left:0;padding-right:0}.___SText_17ogj_gg_:not(:only-child):last-child{padding-left:0}.___SClose_17ogj_gg_{cursor:pointer;flex-shrink:0;padding:var(--intergalactic-spacing-1x, 4px)}@media (hover:hover){.___SClose_17ogj_gg_:hover path{opacity:1}}.___SClose_17ogj_gg_,.___STagContainer_17ogj_gg_{display:inline-flex;position:relative;align-items:center;justify-content:center}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:last-child),.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0;padding-right:var(--intergalactic-spacing-05x, 2px)}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:last-child)::after,.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:last-child)::before,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:last-child)::after,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:last-child)::before{border-right:0;border-top-right-radius:0;border-bottom-right-radius:0;margin-right:-1px}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:last-child) .___SText_17ogj_gg_,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:last-child) .___SText_17ogj_gg_{padding-right:0}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:first-child),.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0;padding-left:var(--intergalactic-spacing-05x, 2px)}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:first-child)::after,.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:first-child)::before,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:first-child)::after,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:first-child)::before{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.___STagContainer_17ogj_gg_ .___SAddon_17ogj_gg_:not(:first-child) .___SText_17ogj_gg_,.___STagContainer_17ogj_gg_ .___STag_17ogj_gg_:not(:first-child) .___SText_17ogj_gg_{padding-left:0}.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_{cursor:pointer;border-top-left-radius:0;border-bottom-left-radius:0;padding-left:0;padding-right:0;min-width:20px}.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_::after,.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_::before{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_::before{left:-1px}.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_ svg{padding-left:0;padding-right:var(--intergalactic-spacing-1x, 4px)}@media (hover:hover){.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_:hover svg path{opacity:1}}.___STagContainer_17ogj_gg_ .___STagContainerClose_17ogj_gg_._size_xl_17ogj_gg_ svg{padding-left:var(--intergalactic-spacing-1x, 4px);padding-right:var(--intergalactic-spacing-2x, 8px)}`,
    "17ogj_gg_"
  ), {
    __SCircle: "___SCircle_17ogj_gg_",
    _size_m: "_size_m_17ogj_gg_",
    _size_l: "_size_l_17ogj_gg_",
    _size_xl: "_size_xl_17ogj_gg_",
    __SAddon: "___SAddon_17ogj_gg_",
    __STagContainer: "___STagContainer_17ogj_gg_",
    __STag: "___STag_17ogj_gg_",
    _disabled: "__disabled_17ogj_gg_",
    __STagContainerClose: "___STagContainerClose_17ogj_gg_",
    _interactiveView: "__interactiveView_17ogj_gg_",
    "_theme_primary-invert": "_theme_primary-invert_17ogj_gg_",
    "_theme_secondary-invert": "_theme_secondary-invert_17ogj_gg_",
    "_theme_additional-invert": "_theme_additional-invert_17ogj_gg_",
    __SText: "___SText_17ogj_gg_",
    _keyboardFocused: "__keyboardFocused_17ogj_gg_",
    "--tag-color": "--tag-color_17ogj",
    _interactive: "__interactive_17ogj_gg_",
    _theme_primary: "_theme_primary_17ogj_gg_",
    _active: "__active_17ogj_gg_",
    _theme_secondary: "_theme_secondary_17ogj_gg_",
    _theme_additional: "_theme_additional_17ogj_gg_",
    __SClose: "___SClose_17ogj_gg_"
  })
), __ = {
  primary: {
    muted: "gray-500",
    info: "blue-500",
    success: "green-500",
    warning: "orange-500",
    danger: "red-500"
  },
  secondary: {
    muted: "gray-50"
  }
}, y = /* @__PURE__ */ function(a) {
  k(t, a);
  var l = E(t);
  function t(r) {
    var _, e;
    return z(this, t), e = l.call(this, r), n(T(e), "state", {
      focusable: "container"
    }), n(T(e), "handleCloseMount", function() {
      e.setState({
        focusable: "text"
      });
    }), n(T(e), "handleCloseUnmount", function() {
      e.setState({
        focusable: "container"
      });
    }), n(T(e), "handleKeyDown", function(g) {
      switch (g.key) {
        case " ":
        case "Enter":
          e.asProps.onClick && (g.preventDefault(), e.asProps.onClick(g));
          break;
      }
    }), N.warn(r.use, `Property 'use' is deprecated, replace property to "theme='`.concat(r.use, "' color='").concat((_ = __[r.use]) === null || _ === void 0 ? void 0 : _[r.theme], `'"`), r["data-ui-name"] || h.displayName), e;
  }
  return A(t, [{
    key: "getCircleProps",
    value: function() {
      var _ = this.asProps, e = _.size, g = _.color, o = _.resolveColor;
      return {
        size: e,
        color: g,
        resolveColor: o
      };
    }
  }, {
    key: "getTextProps",
    value: function() {
      var _ = this.asProps.interactive, e = this.asProps.id || "igc-".concat(this.asProps.uid, "-tag"), g = this.state.focusable;
      return {
        tabIndex: g === "text" && _ ? 0 : -1,
        id: "".concat(e, "-text"),
        role: g === "text" && _ ? "button" : void 0
      };
    }
  }, {
    key: "getCloseProps",
    value: function() {
      var _ = this.asProps, e = _.getI18nText, g = _.color, o = _.resolveColor, s = this.asProps.id || "igc-".concat(this.asProps.uid, "-tag");
      return {
        getI18nText: e,
        id: "".concat(s, "-clear"),
        "aria-labelledby": "".concat(s, "-clear ").concat(s, "-text"),
        "aria-label": e("remove"),
        onMount: this.handleCloseMount,
        onUnmount: this.handleCloseUnmount,
        color: g,
        resolveColor: o
      };
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, e, g = C, o = this.asProps, s = o.Children, c = o.styles, d = o.color, j = o.interactive, S = o.disabled, f = o.addonLeft, $ = o.addonRight, G = o.resolveColor, H = o.id, J = o.uid, O = this.state.focusable, Q = H || "igc-".concat(J, "-tag"), W = !S && j, P = !S && j && O === "container";
      return e = m(c), /* @__PURE__ */ i.createElement(g, e.cn("STag", v({}, p({
        id: Q,
        "use:interactive": P,
        "use:interactiveView": W,
        "tag-color": G(d),
        onKeyDown: this.handleKeyDown,
        "use:tabIndex": P ? 0 : -1,
        role: P ? "button" : void 0
      }, _))), f ? /* @__PURE__ */ i.createElement(h.Addon, {
        tag: f
      }) : null, Y(s, h.Text, [h.Addon, u.Circle]), $ ? /* @__PURE__ */ i.createElement(h.Addon, {
        tag: $
      }) : null);
    }
  }]), t;
}(D);
n(y, "displayName", "Tag");
n(y, "style", K);
n(y, "enhance", [F(w), U(), I(), M()]);
n(y, "defaultProps", {
  theme: "primary",
  color: "gray-500",
  size: "m",
  i18n: w,
  locale: "en"
});
var x = /* @__PURE__ */ function(a) {
  k(t, a);
  var l = E(t);
  function t() {
    return z(this, t), l.apply(this, arguments);
  }
  return A(t, [{
    key: "getTagProps",
    value: function() {
      var _ = this.asProps, e = _.size, g = _.theme, o = _.color, s = _.disabled, c = _.uid, d = _.id, j = _.interactive, S = _.resolveColor, f = d || "igc-".concat(c, "-tag");
      return {
        id: "".concat(f, "-text"),
        disabled: s,
        size: e,
        theme: g,
        color: o,
        tag: j ? "button" : void 0,
        interactive: j,
        resolveColor: S
      };
    }
  }, {
    key: "getCircleProps",
    value: function() {
      var _ = this.asProps, e = _.color, g = _.resolveColor, o = _.size;
      return {
        color: e,
        resolveColor: g,
        size: o
      };
    }
  }, {
    key: "getAddonProps",
    value: function() {
      var _ = this.asProps, e = _.color, g = _.resolveColor;
      return {
        color: e,
        resolveColor: g
      };
    }
  }, {
    key: "getCloseProps",
    value: function() {
      var _ = this.asProps, e = _.size, g = _.theme, o = _.color, s = _.disabled, c = _.uid, d = _.id, j = _.getI18nText, S = _.resolveColor, f = d || "igc-".concat(c, "-tag");
      return {
        disabled: s,
        size: e,
        theme: g,
        color: o,
        id: "".concat(f, "-clear"),
        "aria-labelledby": "".concat(f, "-clear ").concat(f, "-text"),
        "aria-label": j("remove"),
        resolveColor: S
      };
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, e, g = C, o = this.asProps, s = o.styles, c = o.Children, d = o.forcedAdvancedMode, j = d || Z(c, ["InputTags." + h.Text.displayName, "InputTags." + h.Addon.displayName, "InputTags." + h.Close.displayName, "InputTags." + h.Circle.displayName, u.Tag.displayName, u.Addon.displayName, u.Close.displayName, u.Circle.displayName], !0);
      return e = m(s), /* @__PURE__ */ i.createElement(g, e.cn("STagContainer", v({}, p({}, _))), j ? /* @__PURE__ */ i.createElement(c, e.cn("Children", {})) : /* @__PURE__ */ i.createElement(u.Tag, null, /* @__PURE__ */ i.createElement(c, e.cn("Children", {}))));
    }
  }]), t;
}(D);
n(x, "displayName", "TagContainer");
n(x, "style", K);
n(x, "enhance", [F(w), U(), I()]);
n(x, "defaultProps", {
  color: "gray-500",
  theme: "primary"
});
var b = /* @__PURE__ */ function(a) {
  k(t, a);
  var l = E(t);
  function t() {
    var r;
    z(this, t);
    for (var _ = arguments.length, e = new Array(_), g = 0; g < _; g++)
      e[g] = arguments[g];
    return r = l.call.apply(l, [this].concat(e)), n(T(r), "handleKeyDown", function(o) {
      var s = r.asProps, c = s.onKeyDown, d = s.onClick;
      if (c)
        return c(o);
      d && (o.key === "Enter" || o.key === " ") && (o.preventDefault(), d(o));
    }), r;
  }
  return A(t, [{
    key: "render",
    value: function() {
      var _ = this.asProps, e, g = C, o = this.asProps, s = o.Children, c = o.styles, d = o.color, j = o.resolveColor;
      return e = m(c), /* @__PURE__ */ i.createElement(g, e.cn("STagContainerClose", v({}, p({
        tag: "button",
        type: "button",
        interactive: !0,
        interactiveView: !0,
        "tag-color": j(d),
        onKeyDown: this.handleKeyDown
      }, _))), /* @__PURE__ */ i.createElement(s, e.cn("Children", {})));
    }
  }]), t;
}(D);
n(b, "displayName", "CloseTagContainer");
n(b, "style", K);
n(b, "defaultProps", function() {
  return {
    theme: "primary",
    color: "gray-500",
    size: "m",
    i18n: w,
    locale: "en",
    children: /* @__PURE__ */ i.createElement(B.Close, null)
  };
});
n(b, "enhance", [I(), M()]);
function e_(a) {
  var l = arguments[0], t, r = C, _ = C, e = a.styles, g = a.color, o = a.resolveColor;
  return t = m(e), /* @__PURE__ */ i.createElement(r, t.cn("SAddon", {
    "tag-color": o(g)
  }), /* @__PURE__ */ i.createElement(_, t.cn("SCircle", v({}, p({}, l)))));
}
function L(a) {
  var l = arguments[0], t, r = C, _ = a.styles;
  return t = m(_), /* @__PURE__ */ i.createElement(r, t.cn("SText", v({}, p({
    tag: "span"
  }, l))));
}
L.enhance = [M()];
function g_(a) {
  var l = arguments[0], t, r = C, _ = a.styles;
  i.useEffect(function() {
    var g;
    return (g = a.onMount) === null || g === void 0 || g.call(a), N.warn(!0, "Tag.Close is deprecated and will be removed in the next major release. Please, use TagContainer and TagContainer.Close", "Tag.Close"), function() {
      var o;
      return (o = a.onUnmount) === null || o === void 0 ? void 0 : o.call(a);
    };
  }, []);
  var e = i.useCallback(function(g) {
    if (a.onKeyDown)
      return a.onKeyDown(g);
    a.onClick && (g.key === "Enter" || g.key === " ") && (g.preventDefault(), a.onClick(g));
  }, [a.onKeyDown, a.onClick]);
  return t = m(_), /* @__PURE__ */ i.createElement(r, t.cn("SClose", v({}, p({
    tag: R,
    interactive: !0,
    onKeyDown: e
  }, l))));
}
function q(a) {
  var l = arguments[0], t, r = C, _ = a.styles, e = a.color, g = a.resolveColor, o = i.useMemo(function() {
    if (typeof g == "function")
      return g(e);
  }, [e, g]);
  return t = m(_), /* @__PURE__ */ i.createElement(r, t.cn("SAddon", v({}, p({
    tag: "div",
    "tag-color": o
  }, l))));
}
function o_(a) {
  var l = arguments[0], t, r = C, _ = a.styles, e = a.color, g = a.resolveColor, o = i.useMemo(function() {
    if (typeof g == "function")
      return g(e);
  }, [e, g]);
  return t = m(_), /* @__PURE__ */ i.createElement(r, t.cn("SCircle", v({}, p({
    tag: "span",
    "tag-color": o
  }, l))));
}
var h = V(y, {
  Text: L,
  Addon: q,
  Close: g_,
  Circle: o_
}), B = V(b, {
  Close: R
}), u = V(x, {
  Tag: h,
  Addon: q,
  Close: B,
  Circle: e_
});
export {
  u as TagContainer,
  h as default
};
